<template>
  <div class="content">
    <skeletonIndex v-if="skeletonLoading" />
    <div v-else>
      <template v-for="(item,index) in module_list" >
        <banner-item v-if="item.type=='banner'" :key="index" :param="item"></banner-item>
        <navIcon v-if="item.type=='icon'" :key="index" :param="item"></navIcon>
        <course v-if="item.type=='course'" :key="index" :param="item"></course>
        <giftGoods v-if="item.type=='giftGoods'" :param="item" :key="index"></giftGoods>
        <goodsItem v-if="item.type=='goods' && item.data != ''" :param="item" :key="index"></goodsItem>
        <previewItem v-if="item.type=='preview'" :param="item" :key="index"></previewItem>
        <adItem v-if="item.type=='adv'" :param="item" :key="index"></adItem>
        <minitOneItemNo v-if="item.type=='onepay' && show_status==1" :param="item" :fullTime="full_time" :showStatus="show_status" :showTime="showTime" :msTxtShow="msTxtShow"  :key="index"></minitOneItemNo>
        <minitOnePayItem v-if="item.type=='onepay' && show_status==0" :param="item" :fullTime="full_time" :showStatus="show_status" :showTime="showTime" :msTxtShow="msTxtShow"  :key="index"></minitOnePayItem>
      </template>
    </div>
    <div class="null-box" style="padding-bottom: 6.66667vw;"></div>
    <div v-show="gotop" class="top-icon-box" @click="toTop">
      <img class="top-icon" :src="require('../assets/'+picTheme+'/top_icon.png')" alt="" />
    </div>

  </div>
</template>

<script>
import skeletonIndex from "@/components/skeleton/skeletonIndex";
import bannerItem from "@/components/home/bannerItem";
import course from "@/components/home/course";
import giftGoods from "@/components/home/giftGoods";
import goodsItem from "@/components/home/goodsItem";
import navIcon from "@/components/home/navIcon";
import adItem from "@/components/home/adItem";
import previewItem from "@/components/home/previewItem";
import minitOneItemNo from "@/components/home/minitOneItemNo";
// import onepayItem from "@/components/home/onepayItem";
import minitOnePayItem from "@/components/home/minitOnePayItem";
import { wexinShare } from "@/utils/shareInfo";
import { getWechat} from "@/api/zhibo";
import { systemConfig} from '@/api/info'

export default {
  name: "HomeSec",
  data(){
    return{
      picTheme: 'dengyun',
      scrollTop: '',
      skeletonLoading:true,
      module_list: [], //首页全部数据
      endTime:'2021-10-15 15:58',
      finishedTime: '', // 活动结束时间
      showTime: {
        H: 0,
        M: 0,
        S: 0
      }, //倒计时
      msTxtShow: false, // false:显示倒计时  true：显示秒杀中
      msIsShow: false, // 判断秒杀是否显示
      colorMs: false, // 当天有秒杀 颜色为红色 别的为灰色
      full_time: '', // 开抢时间
      tips_time: '', // 提示购买文案
      show_status: 1,// 1显示 0隐藏倒计时
      from_name:'', // 后退页面
      is_top: false,
      toTopShow:false,
      gotop:false,
      srcoll:0,
      pic:''
    }
  },
  components: {
    skeletonIndex,
    bannerItem,
    course,
    giftGoods,
    navIcon,
    goodsItem,
    adItem,
    previewItem,
    // onepayItem
    minitOnePayItem,
    minitOneItemNo
  },
  watch: {
    srcoll() {
      if (this.srcoll > 400) {
        this.toTopShow = true;
      } else {
        this.toTopShow = false;
      }
    },
  },
  beforeCreate() {		//在页面创建之前设置body的背景色
    document.querySelector('body').setAttribute('style', 'background: #f5f5f5;')
  },
  beforeRouteLeave(to, from, next) { // 记录当前离开位置，为了返回后回到之前位置
    // let position = window.scrollY //记录离开页面的位置
    // console.log('离开位置',position)
    // if (position == null) position = 0
    // this.$store.commit('changeRecruitScrollY', position) //离开路由时把位置存起来
    // console.log('to',to)
    if (to.name == 'GoodDetails' || to.name == 'goodClassify' || to.name == 'activityTheme'){
      //当离开的时候是去首页的时候开启缓存

      from.meta.isBack = true;
      // console.log('meta离开',from.meta)
    }else {
      // console.log('meta',from.meta)
      from.meta.isBack = false;
    }
    next()
  },
  activated(){
    // console.log('activated')
    let http = window.location.protocol+'//'
    let url = window.location.hostname // 获取当前访问（域名）
    this.pic = http+url+'/logo.jpg' //'https://jpzs-zst.itos.cn/logo.jpg'
    if (!this.$route.meta.isBack) { // false
      // console.log('isBack',this.$route.meta.isBack)
      //isBack 时添加中router中的元信息，判读是否要缓存
      this.resetQuery(); //清空原有数据
      this.getIndexArrData() // 首页数据 // 重新加载
    } else { // 要缓存
      // console.log('activated isBack',this.$route.meta.isBack)
      // 执行倒计时函数
      if (this.show_status == 1){
        this.showTimes()
      }

    }
    let token = this.$store.state.token
    if (token == ''){
      this.$store.commit('setTabbarShow',false);
    } else {
      // console.log('you token ')
      this.login= 1; // 隐藏登录
      this.$store.commit('setTabbarShow',true);
    }
    this.$route.meta.isBack = false; // 通过这个控制刷新，否则会一直为true

    // 判断是否显示置顶icon
    // window.addEventListener("scroll", this.srcollShow);
    window.addEventListener("scroll", this.handleScroll, true);
  },
  created () {
    // this.getlist()
    // console.log('token',window.g.templateIds[0])
    // console.log('created')
    let that = this
    let token = that.$store.state.token
    // var token = 'Bearer 1|lQMa9L71V0A86jD3xcqBNI6yrvIEx2dTAkccpfdT'
    if (token == ''){
      that.$store.commit('setTabbarShow',false);
    } else {
      // console.log('you token ')
      that.login= 1; // 隐藏登录
      that.$store.commit('setTabbarShow',true);
    }
    // that.getIndexArrData() // 新版本首页数据
    // 清掉下单信息，防止存储过多
    this.$store.commit("setGoodsInfo",'');
    this.$store.commit("setSubmitNumber",'')
    this.$store.commit("setPayTypeId",'')// 一元购
    this.$store.commit("setPayInfo",'');
    this.$store.commit("setCartIds",'');
    this.$store.commit("setLiveItem",'')
  },
  // mounted() {
  //   window.addEventListener("scroll",this.handleScroll);
  // },
  // destroyed() {
  //   document.removeEventListener('scroll', this.handleScroll)
  // },
  methods: {
    getSystemConfig(){ // 获取主题色
      systemConfig().then(res=>{
        if (res.code == 200){
          console.log(res)
          this.picTheme = res.data.theme // 'health' //
          this.$store.commit("setAppTheme", res.data.theme);
        }
      })
    },
    getShareWx() { // 微信分享注入
      // 获取设备信息并判断是否是ios
      var pageUrl = ''
      let u = navigator.userAgent;
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) { // ios
        // ios系统就拼接随机字符串
        pageUrl = this.$store.state.wxSignUrl
      } else {
        pageUrl = location.href.split('#')[0]
      }
      const data = {
        liveUrl: pageUrl // encodeURIComponent(location.href.split('#')[0]) //  pageUrl
      }
      getWechat(data).then(res => {
        if (res.code == 200) {
          //微信加签
          let weChat = res.data
          const obj = {
            appId: weChat.appId, // 必填，公众号的唯一标识
            timestamp:weChat.timestamp , // 必填，生成签名的时间戳
            nonceStr: weChat.nonceStr, // 必填，生成签名的随机串
            signature: weChat.signature,// 必填，签名
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
            openTagList: ['updateAppMessageShareData', 'updateTimelineShareData']
          };
          let urlPath = location.href.split('#')[0]
          const shareData = {
            title: '全球灯云',
            desc: ' ',
            link: urlPath,
            imgUrl: this.pic
          }
          wexinShare(obj,shareData) // 引用微信分享
        } else {
          this.$toast(res.message)
        }
      })
    },
    handleScroll() {
      //注意不同浏览器之间的兼容性
      let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
      scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
    },
    toTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 80;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    resetQuery(){
      this.module_list = []
      this.skeletonLoading = true
      this.endTime='2021-10-15 15:58'
        this.finishedTime= '' // 活动结束时间
        this.showTime= {
        H: 0,
          M: 0,
          S: 0
      }, //倒计时
      this.msTxtShow= false // false:显示倒计时  true：显示秒杀中
        this.msIsShow= false // 判断秒杀是否显示
        this.colorMs= false // 当天有秒杀 颜色为红色 别的为灰色
        this.full_time= '' // 开抢时间
        this.tips_time= '' // 提示购买文案
        this.show_status= 1// 1显示 0隐藏倒计时
      this.$store.commit("setGoodsInfo",'');
      this.$store.commit("setSubmitNumber",'')
      this.$store.commit("setPayTypeId",'')// 一元购
      this.$store.commit("setPayInfo",'');
      this.$store.commit("setCartIds",'');
    },
    // handleScroll(){
    //   let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    //   // console.log(scrollTop)
    // },
    async getIndexArrData(){ // 首页数据
      const res = await this.$Http.getIndexArr()
      // console.log('index',res.data)
      if (res.code == 200){
        this.getShareWx()
        this.skeletonLoading = false
        this.module_list = res.data
        let obj_one =  ''
        let arr =  this.module_list
        arr.forEach(function(val,index){
          if (val.type == 'onepay'){
            obj_one = val
          }
        });
        // this.full_time = obj_one.data[0].date
        if (obj_one != ''){
          this.full_time =obj_one.data[0].tips_time // 秒杀日期
          // console.log('time',this.full_time)
          var endTime = obj_one.data[0].full_time // 几点钟 4点
          this.endTime = endTime  // 秒杀时间
          this.finishedTime =this.getTime(1)+ ' '+ '00:00' // 秒杀时间<=现在<次日0点：秒杀中   得到 后1 天的时间

          this.show_status = obj_one.data[0].show_status
          console.log('staus',this.show_status)

          //  判断是否在秒杀中解决后退
          let nowTimeCurr = new Date().getTime(); // 当前时间
          let startDate = obj_one.data[0].time; // 四点钟倒计时
          // console.log('startDate',startDate)
          startDate = startDate.replace(new RegExp('-', 'gm'), '/');
          let startDateM = new Date(startDate).getTime(); //得到毫秒数
          // console.log('startDate',startDate)
          let lefttime = startDateM - nowTimeCurr;
          if (lefttime > 0) { // 倒计时中
            this.msTxtShow = false //  false:显示倒计时  true：显示秒杀中
            // console.log('false:显示倒计时')
          }else {
            this.msTxtShow = true
          }
          //  判断是否在秒杀中解决后退end
          if (this.show_status == 1){
            this.showTimes()
          }
        }

      }else {
        this.$toast(res.message)
      }
    },
    getTime(val) { //   获取时间并格式化
      // 获取前val天的时间
      var dt = new Date;
      val === 0 ? '' : dt.setTime(dt.getTime() + 24 * 60 * 60 * 1000 * val)
      const y = dt.getFullYear();
      const m = (dt.getMonth() + 1 + "").padStart(2, "0");
      const d = (dt.getDate() + "").padStart(2, "0");
      return `${y}-${m}-${d}`;  // 获取的时间格式为 2021-04-09 09:34:00
      // return `${y}-${m}-${d} `;  // 获取的时间格式为 2021-04-09
      // return y+m+d+hh+mm+ss  // 获取的时间格式为 20210409093733
      // return y + m + d  // 获取的时间格式为  20210409
    },
    showTimes(val) {
      let that = this;
      let interval = setInterval(() => {
        let nowTime = new Date().getTime(); // 当前时间
        let startDate = that.endTime; // 四点钟倒计时
        startDate = startDate.replace(new RegExp('-', 'gm'), '/');
        let startDateM = new Date(startDate).getTime(); //得到毫秒数
        // console.log('startDate',startDate)
        let lefttime = startDateM - nowTime;
        if (lefttime > 0) { // 倒计时中
          that.showTime.H = Math.floor(lefttime / (1000 * 60 * 60)) < 10 ? '0' + Math.floor(lefttime / (1000 * 60 * 60)) : Math.floor(lefttime / (1000 * 60 * 60)); //计算小时数
          that.showTime.M = Math.floor((lefttime / (1000 * 60)) % 60) < 10 ? '0' + Math.floor((lefttime / (1000 * 60)) % 60) : Math.floor((lefttime / (1000 * 60)) % 60); //计算分钟数
          that.showTime.S = Math.floor((lefttime / 1000) % 60) < 10 ? '0' + Math.floor((lefttime / 1000) % 60) : Math.floor((lefttime / 1000) % 60); //计算秒数
          this.msTxtShow = false //  false:显示倒计时  true：显示秒杀中
        } else { // 秒杀时间<=现在<次日0点：秒杀中
          // console.log('秒杀中')
          let nowTime = new Date().getTime(); // 当前时间
          let finishedTime = this.getTime(1)+ ' '+ '00:00' // 秒杀时间<=现在<次日0点：秒杀中   得到后1 天的时间
          // console.log('当前finishedTime',finishedTime)
          let finishedTimeDate = finishedTime.replace(new RegExp('-', 'gm'), '/');
          let finishedTimeM = new Date(finishedTimeDate).getTime(); //得到毫秒数 第二天时间
          // console.log('finishedTimeM',finishedTimeM)

          this.msTxtShow = true
          // this.msTxtShow = true //  false:显示倒计时  true：显示秒杀中
          that.showTime.H = '00';
          that.showTime.M = '00';
          that.showTime.S = '00';
          clearInterval(interval);
        }
      }, 1000);
    },
  }
}
</script>

<style lang="scss" scoped>
.top-icon-box{
  position: fixed;right: 30px;bottom: 300px;z-index: 88;width: 100px;
  border-radius: 100px;
  box-shadow:0 0 20px #bbbbbb;
  .top-icon{
    width: 100%;height: auto;display: block;
  }
}

.ad-block-2 {
  width: 664px;
  padding: 0 15px;
  margin: 0 auto 23px;text-align: left;background: #ffffff;border-radius: 12px;
  .down-time{
    display: inline-block;
    span{
      background: #F23926;color: #ffffff;
      border-radius: 8px;display: inline-block;padding: 2px 10px;font-size: 24px;
    }
  }
  .title-box{
    display: inline-block;font-size: 32px;color: #1D1D1D;font-weight: bold;margin-left: 24px;
    position: relative;padding: 22px 0;
    .title-txt{
      width: 143px;text-align: center;
    }
    .title-box-line{
      width: 143px;
      height: 15px;
      background: #FEDC32;
      border-radius: 8px;margin-top: -15px;
    }
  }

}

</style>
